const ADDRESS_LENGTH = 40;
const INVALID_CHARACTERS = /([^0-9a-fA-F])/;

function validateCharacterSet(str) {
  return !INVALID_CHARACTERS.test(str);
}

// eslint-disable-next-line no-unused-vars
function validateChecksum(str) {
  // TODO: https://github.com/ethereum/EIPs/issues/55
  return true;
}

export default function isAddress(value) {
  let standardizedAddress = '';
  if (value.substr(0, 2).toLowerCase() === '0x') {
    standardizedAddress = value.substr(2);
  } else {
    standardizedAddress = value;
  }

  if (!validateCharacterSet(standardizedAddress)) return false;
  if (!validateChecksum(standardizedAddress)) return false;

  return standardizedAddress.length === ADDRESS_LENGTH;
}



// WEBPACK FOOTER //
// ./src/utilities/ethereumAddress.js